export default __webpack_public_path__ + "static/lab-visit-neutral-b3dc7b297bdc217b708c190eebf54c13.jpg";